(function () {
  const SELECTOR = 'native-carousel[data-autorotate="true"]';

  function start(el) {
    const interval = Number(el.dataset.interval) || 5000;
    const dots = el.querySelector('page-dots');
    if (!dots) return;

    const next = () => {
      const current = dots.querySelector('button[aria-current="true"]');
      const target = (current && current.nextElementSibling) || dots.querySelector('button:first-child');
      if (target) target.click();
    };

    let timer = setInterval(next, interval);

    // Pause on hover/focus/touch
    const pause = () => { clearInterval(timer); timer = null; };
    const resume = () => { if (!timer) timer = setInterval(next, interval); };

    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('focusin', pause);
    el.addEventListener('focusout', resume);
    el.addEventListener('touchstart', pause, { passive: true });
    el.addEventListener('touchend', resume, { passive: true });

    // Keep a handle so we can clean up if the section reloads
    el._autorotate_cleanup = () => { pause(); el.removeEventListener('mouseenter', pause); el.removeEventListener('mouseleave', resume); el.removeEventListener('focusin', pause); el.removeEventListener('focusout', resume); el.removeEventListener('touchstart', pause); el.removeEventListener('touchend', resume); };
  }

  function init(root = document) {
    root.querySelectorAll(SELECTOR).forEach((el) => {
      // avoid double init
      if (el._autorotate_cleanup) el._autorotate_cleanup();
      start(el);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init());

  // Make it work inside the Theme Editor (sections re-render)
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll(SELECTOR).forEach((el) => el._autorotate_cleanup && el._autorotate_cleanup());
  });
})();